export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

// Espelha ALLOWED_ATTACHMENT_MIME_TYPES do backend (cronogramaRoutes.ts)
export const ACCEPTED_MIME = new Set([
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/plain',
  'text/csv',
  'image/jpeg',
  'image/png',
  'image/webp',
]);
export const ACCEPT_ATTR = '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.jpg,.jpeg,.png,.webp';
export const MAX_ANEXO_BYTES = 10 * 1024 * 1024;

/** Retorna a mensagem de erro se o arquivo violar tamanho/tipo aceitos, ou `null` se válido. */
export function validarAnexo(file: File): string | null {
  if (file.size > MAX_ANEXO_BYTES) return `"${file.name}" excede o tamanho máximo (10 MB)`;
  if (file.type && !ACCEPTED_MIME.has(file.type)) {
    return `"${file.name}": tipo não permitido. Envie PDF, imagem ou documento Office.`;
  }
  return null;
}
